import { EntityReportDet } from "./EntityReportDet";

export class EntityReportDetImple  extends EntityReportDet {
public c_report_det_type_name:string | null = null;
}